<section>
    <form [formGroup]="form" class="row">
        <div class="col-md-5">
            <mat-form-field appearance="outline">
                <mat-label>{{options.label_date}}<span class="asterisk" *ngIf="options.mandatory">*</span></mat-label>
                <input type="text" matInput name="date" [matDatepicker]="date" (click)="date.open()"
                    (dateChange)="changeDate($event)" [formControl]="date_control" readonly>
                <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                <mat-datepicker #date></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-md-7 text-right">
            <div class="d-inline-flex w-100" style="padding-top: 0.5em;">
                <div class="text-left w-100" class="time-label-container">
                    <label>{{options.label_time}}</label>
                </div>
                <div class="time-input-container">
                    <mat-form-field>
                        <mat-select [formControl]="time_control" name="time_control_select"
                            (selectionChange)="changeTime($event)">
                            <span *ngFor="let h of hours;">
                                <mat-option *ngFor="let m of minutes" value="{{h | number:'2.0'}}:{{m | number:'2.0'}}">
                                    {{h | number:'2.0'}}:{{m | number:'2.0'}}
                                </mat-option>
                            </span>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div>
                    <mat-button-toggle-group [formControl]="am_pm_control" *ngIf="!options.militar"
                        (change)="changeTimeAmPm($event)">
                        <mat-button-toggle value="am">
                            AM
                        </mat-button-toggle>
                        <mat-button-toggle value="pm">
                            PM
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </div>
    </form>
</section>